export const sizePerPageList = [
  { text: "10", value: 10 },
  { text: "15", value: 15 },
  { text: "30", value: 30 }
];

export const initialFilter = {
  organization_name: "",
  organization_uuid: "",
  pageNumber: 1,
  pageSize: 10
};
